import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  private static readonly ROUTE_DATA_BREADCRUMB = 'breadcrumb';
  private static readonly ROUTE_DATA_BREADCRUMB_DISABLED = 'breadcrumbDisabled';
  readonly home = {icon: 'pi pi-home', url: '/', label: 'menu.home'};
  menuItems!: MenuItem[];

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit(): void {
    // 從 Root 開始產生麵包屑
    this.menuItems = this.createBreadcrumbs(this.activatedRoute.root);
  }

  private createBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: MenuItem[] = []): MenuItem[] {
    const children: ActivatedRoute[] = route.children;

    if (children.length === 0) {
      return breadcrumbs;
    }

    for (const child of children) {
      const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

      if (routeURL !== '') {
        url += `/${ routeURL }`;

        const routeConfigData = child.snapshot.routeConfig?.data;

        let label;
        let disabled;
        if (routeConfigData != null) {
          label = routeConfigData[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB];
          disabled = routeConfigData[BreadcrumbComponent.ROUTE_DATA_BREADCRUMB_DISABLED];
          if (this.isNullOrUndefined(disabled)) {
            disabled = false;
          }
        }

        if (!this.isNullOrUndefined(label)) {
          breadcrumbs.push({ 'label': label, 'url': url, 'disabled': disabled });
        }
      }
      return this.createBreadcrumbs(child, url, breadcrumbs);
    }

    return breadcrumbs;
  }

  private isNullOrUndefined(object: any): boolean {
    return object === null || object === undefined;
  }

  itemClick(event: any, item: MenuItem) {

    if (item.disabled) {
        event.preventDefault();
        return;
    }

    if (!item.url && !item.routerLink) {
        event.preventDefault();
    }

    if (item.command) {
      item.command({
        originalEvent: event,
        item: item
      });
    }
  }
}
